// @ts-check
import React, { Component } from 'react';
import { Page, Row, Widget } from 'shared/containers/portal_layout';
import api from 'utils/api';
import LoadingContent from 'shared/components/LoadingContent';
import PatientMemberHeader from '../PatientMemberHeader';
import { Link } from 'react-router';
import PatientCoverageDetails from 'shared/components/PatientCoverageDetails';

class Show extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { patientMember: null };
  }

  componentDidMount() {
    this.fetchPatientMember();
  }

  fetchPatientMember = () => {
    api.get(`/agent_portal/api/patient_members/${this.props.params.id}`).then(response => {
      this.setState({ ...response.data });
    });
  };

  render() {
    if (!this.state.patientMember) return <LoadingContent />;
    return (
      <PresentationComponent
        patientMember={this.state.patientMember}
        appointments={this.state.appointments}
      />
    );
  }
}

const PresentationComponent = ({ patientMember, appointments }) => (
  <Page
    title="Patient Information"
    extraTitleContent={
      <span>
        <Link to={`/a/portal/patient_members/${patientMember.id}/edit`} className="btn btn-warning">
          Edit Patient Info
        </Link>
      </span>
    }
  >
    <PatientMemberHeader patientMember={patientMember} />
    <Row>
      <Widget title="Timeline/Appointments" span={6}>
        <table className="table table-bordered table-stiped table-hover appointments">
          <thead>
            <tr>
              <th>What</th>
              <th>Date</th>
              <th>Time</th>
              <th>Provider</th>
              <th>Status</th>
              <th>Location</th>
              <th>Organization</th>
            </tr>
          </thead>
          <tbody>
            {appointments.map(a => (
              <tr className={a.cssClasses} key={a.id}>
                <td>
                  {a.canView ? (
                    <Link to={`/a/portal/referrals/${a.referralId}`}>Referral</Link>
                  ) : (
                    'Referral'
                  )}
                </td>
                <td>{a.startDate}</td>
                <td>{a.startTime}</td>
                <td>{a.providerName}</td>
                <td>{a.statusName}</td>
                <td>{a.locationName}</td>
                <td>{a.organizationName}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Widget>

      <Widget title="Insurance" span={6}>
        <PatientCoverageDetails
          allowInsuranceCoverageData={false}
          patientCoverage={patientMember.patientCoverage}
        />
      </Widget>
    </Row>
  </Page>
);

export default Show;
